import { render, staticRenderFns } from "./supplier-managenment.vue?vue&type=template&id=ebfeaede"
import script from "./supplier-managenment.vue?vue&type=script&lang=js"
export * from "./supplier-managenment.vue?vue&type=script&lang=js"
import style0 from "./supplier-managenment.vue?vue&type=style&index=0&id=ebfeaede&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports